export default "__VITE_ASSET__BDmAEAPt__"